module.exports = require("mz");


//////////////////
// WEBPACK FOOTER
// external "mz"
// module id = 1
// module chunks = 0